// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","host":"bundle-purchase-v2_host__u30sV"};